import { render, staticRenderFns } from "./ExpandCard.vue?vue&type=template&id=be0b6316&scoped=true&"
import script from "./ExpandCard.vue?vue&type=script&lang=js&"
export * from "./ExpandCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandCard.vue?vue&type=style&index=0&id=be0b6316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0b6316",
  null
  
)

export default component.exports